module.exports = __webpack_public_path__ + "img/gelenevrak.99215af3.png";